module.exports = __webpack_public_path__ + "img/login.ff774657.svg";